// MUI-free copy of Ui-components/LatestCta.
import {memo} from 'react';
import type {MouseEventHandler, ReactNode} from 'react';
import Link from 'next/link';
import parse from 'html-react-parser';
import Container from '@/components/atoms/Container';
import {cdnUrl} from '@/util/cdnImage';
import styles from './LatestCta.module.scss';

interface LatestCTAProps {
    heading?: ReactNode;
    subheading?: string;
    buttonText?: ReactNode;
    /** Click handler, or — with `meetingLink` — the URL the button links to. */
    openForm?: MouseEventHandler<HTMLButtonElement> | string;
    className?: string;
    meetingLink?: boolean | string;
}

// latestCtaMainWrapperSx background. Inline so it reaches the same URL as the original; every caller's
// `.blue-background-cta` (globals.scss, !important) still replaces it, exactly as it beat the sx before.
const WRAPPER_STYLE = {backgroundImage: `url(${cdnUrl('Squeeze-offer-page/Cta-bg.webp')})`} as const;

const BUTTON_CLASS = `latest-cta-button-wrapper animated-button ${styles.button}`;

const LatestCTA = ({heading, subheading, buttonText, openForm, className, meetingLink}: LatestCTAProps) => (
    <div>
        <Container>
            <div className={`latest-cta-main-wrapper ${className} ${styles.wrapper}`} style={WRAPPER_STYLE}>
                <div className={styles.grid}>
                    <div className={`${styles.item} ${styles.copyItem}`}>
                        <div className={`spectrum-header-wrapper solution-header-wrapper solutions left  ${styles.header}`}>
                            <p className={`spectrum-heading color-black  ${styles.heading}`}>{heading}</p>
                            {subheading && (
                                <p className={`solution-sub-heading color-black data_links ${styles.subheading}`}>
                                    {subheading ? parse(subheading) : ''}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={`${styles.item} ${styles.buttonItem}`}>
                        {meetingLink ? (
                            <Link target="_blank" href={openForm as string}>
                                <button type="button" className={BUTTON_CLASS}>
                                    {buttonText}
                                </button>
                            </Link>
                        ) : (
                            <button type="button" className={BUTTON_CLASS} onClick={openForm as MouseEventHandler<HTMLButtonElement>}>
                                {buttonText}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </Container>
    </div>
);

export default memo(LatestCTA);
